import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import sendGTMEvent from '../../../../../../common/analytics/sendGTMEvent';
import { HeaderTrackingElementName } from '../../../../../../common/analytics/types/header';
import { PopupContent, PopupContentWrapper } from '../../styled/Popup.styled';
import { SignInButton, SignUpLink, SignUpParagraph, VisitorPopup as StyledVisitorPopup, } from './VisitorPopup.styled';
export const VisitorPopup = ({ onLogin, onSignUp }) => {
    useEffect(() => {
        sendGTMEvent({
            event: 'account_drawer_impression',
            element_name: HeaderTrackingElementName.JOIN,
            device_category: 'desktop',
        });
    }, []);
    const trackAccountDrawerClickDesktop = (elementName) => {
        sendGTMEvent({
            event: 'account_drawer_click',
            element_name: elementName,
            device_category: 'desktop',
        });
    };
    return (_jsx(StyledVisitorPopup, { children: _jsx(PopupContent, { children: _jsxs(PopupContentWrapper, { children: [_jsx(SignInButton, Object.assign({ onClick: () => {
                            sendGTMEvent({
                                event: 'account_drawer_click',
                                element_name: HeaderTrackingElementName.LOG_IN,
                                device_category: 'desktop',
                            });
                            onLogin && onLogin();
                        } }, { children: "Log in" }), void 0), _jsxs(SignUpParagraph, { children: ["Don't have an account yet?\u00A0", _jsx(SignUpLink, Object.assign({ href: "/auth/signin/register-user", onClick: () => {
                                    trackAccountDrawerClickDesktop(HeaderTrackingElementName.SIGN_UP);
                                    onSignUp && onSignUp();
                                } }, { children: "Sign up" }), void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=VisitorPopup.js.map